import { Loader2 } from "lucide-react";

export function PaginaLoader({ label }: { label?: string }) {
  return (
    <div className="flex items-center justify-center py-20 text-muted-foreground">
      <Loader2 className="h-5 w-5 animate-spin mr-2" />
      {label ?? "Laden…"}
    </div>
  );
}
